import { render, staticRenderFns } from "./AccordionBlock.vue?vue&type=template&id=b7772236&scoped=true&"
import script from "./AccordionBlock.vue?vue&type=script&lang=js&"
export * from "./AccordionBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/AccordionBlock.scss?vue&type=style&index=0&id=b7772236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7772236",
  null
  
)

export default component.exports